import type { PropDefaults, PropElement, PropTypes } from "@platform/react-storybook/Component";
import type { UuidText } from "../../Text/types";

import type { PropCard } from "../types";
import Namespace from "./_index.scss";

export const { NAME_HORIZONTAL_CARD, TYPE_HORIZONTAL_CARD } = Namespace;

type PropParent = Required<Pick<PropCard, "href" | "bitmap">>;

export type PropHorizontalCard = PropElement &
    PropParent & {
        title: UuidText;
        summary: UuidText;
        pills?: UuidText[];
    };

export const DEF_HORIZONTAL_CARD: PropDefaults<Omit<PropHorizontalCard, "pills">> = {};

export type PropTypesHorizontalCard = PropTypes<PropHorizontalCard, typeof DEF_HORIZONTAL_CARD>;
